export default "__VITE_ASSET__BGFsjjBa__"